import { initialState } from '..'
import { SET, SET_UPGRADE_CREDITS_FOR_PRODUCT_SPECIFCATION } from '../../actions/entitlement/entitlement'
import { getProductDefinitionId } from '../../../util/get-definition/getDefinition'
import type { EntitlementsActions } from '../../actions/entitlement/entitlement'
import type { SiteAlias } from '../../../schema/webshop-package'

export type Product = {
  type: 'jobposting' | 'upgradedjobposting' | 'jobupgrade' | 'profileview' | 'performancebased'
  name: string
  features: string[] // ToDo: Change it to Feature[] from schema/webshop-package'
}

export type ProductUpgrade = Product & {
  requiredFeatures: string[]
  requiredSites: SiteAlias[]
  sites?: SiteAlias[]
  requirements: string[]
}

export type JobProductPredefinedType = {
  [key: string]: string
}

export type JobPostingProduct = Product & {
  publishOn: SiteAlias[]
  daysOnline: number
  predefined: JobProductPredefinedType
}

export type ProfileViewProduct = Omit<Product, 'features'>

export type PerformanceBasedProduct = Omit<Product, 'features'>

export type AccessPeriod = {
  start: string
  end: string
  numberOfDaysAccessible: number
}

type BaseEntitlement = {
  id: string
  available: number
  accessPeriod: AccessPeriod
}

export type JobPostingEntitlement = BaseEntitlement & {
  product: JobPostingProduct
}

export type JobPostingUpgradeEntitlement = BaseEntitlement & {
  product: ProductUpgrade
}

export type ProfileViewEntitlement = BaseEntitlement & {
  product: ProfileViewProduct
}

export type PerformanceBasedEntitlement = BaseEntitlement & {
  product: PerformanceBasedProduct
}

export type EntitlementType =
  | JobPostingEntitlement
  | JobPostingUpgradeEntitlement
  | ProfileViewEntitlement
  | PerformanceBasedEntitlement

export type Entitlements = Array<EntitlementType>

export type JobPostingEntitlements = Array<JobPostingEntitlement>

export type ProfileViewEntitlements = Array<ProfileViewEntitlement>

export type JobUpgradeEntitlements = Array<JobPostingUpgradeEntitlement>

export type PerformanceBasedEntitlements = Array<PerformanceBasedEntitlement>

export type EntitlementStoreType = {
  jobPostings: JobPostingEntitlements
  jobUpgrades: JobUpgradeEntitlements
  profileViews: ProfileViewEntitlements
  performanceBased: PerformanceBasedEntitlements
  upgradeCredits: {
    [key: string]: Array<JobPostingUpgradeEntitlement>
  }
  entitlementsAreLoaded: boolean
}

const reducer = (state: EntitlementStoreType, { type, payload }: EntitlementsActions): EntitlementStoreType => {
  if (!state) return initialState.entitlements

  switch (type) {
    case SET:
      return {
        ...state,
        jobPostings: payload.filter(({ product }) => product.type === 'jobposting') as JobPostingEntitlements,
        jobUpgrades: payload.filter(({ product }) => product.type === 'jobupgrade') as JobUpgradeEntitlements,
        profileViews: payload.filter(({ product }) => product.type === 'profileview') as ProfileViewEntitlements,
        performanceBased: payload.filter(({ product }) => product.type === 'performancebased') as PerformanceBasedEntitlements,
        entitlementsAreLoaded: true,
      }

    case SET_UPGRADE_CREDITS_FOR_PRODUCT_SPECIFCATION:
      return {
        ...state,
        upgradeCredits: {
          ...state.upgradeCredits,
          [getProductDefinitionId(payload.productSpecification)]: payload.entitlements,
        },
      }

    default:
      return state
  }
}

export default reducer
